

<app-select [(selected)]="selected" [data]="data" (selectedChange)="changeLang($event)"></app-select>